import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsRegistryDashboardStats extends SnModel {
  @Expose()
  public countTotalRegistrySites: number;

  @Expose()
  public countTotalRegistryInternalCameras: number;

  @Expose()
  public countTotalRegistryExternalCameras: number;

  @Expose()
  public countNewRegistryByPeriod: number;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
